import React from "react"

import { css } from "@emotion/react"

import { PrimaryText } from "./primaryText.element"

export const OfflineElement: React.FunctionComponent = () => {
    return (
        <div css={styles.wrapper}>
            <PrimaryText typography="h1" centered>
                Oops...
            </PrimaryText>

            <PrimaryText typography="text" centered css={styles.subtitle}>
                Looks like you are offline.
            </PrimaryText>
        </div>
    )
}

const styles = {
    wrapper: css({
        width: "100%",
        maxWidth: "1290px",
        paddingLeft: "120px",
        paddingRight: "50px",
        marginBottom: 20,
    }),
    subtitle: css({
        marginTop: 24,
    }),
}
